import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalPruebaSM = ({ toggleFunction, modalState }) => {
  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Aviso Concurso 2025</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner sm card' /> */}

          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group mt-1 mb-3'>
            <p className='heading-title-sm fw-semibold mb-2'>Recepción de Credenciales</p>
            <p>Hasta el lunes 06/10/2025</p>
          </div>

          <div className='info-group mb-3'>
            <p className='fw-semibold'>Esta semana tendremos atención al público para el Concurso el día Sábado 04/10/2025</p>
          </div>

          <div className='info-group mb-4'>
            <p className='heading-title-sm fw-semibold mb-2'>Horario de Atención</p>
            <p>Lunes a viernes de 8:00 AM a 4:00 PM</p>
          </div>

          <div className='info-group mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-0'>Director</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalPruebaSM }